export default __webpack_public_path__ + "static/media/copyright.e8dd4eb6.png";